var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "navigation-wrapper" }, [
      _c(
        "div",
        {
          ref: "slider",
          staticClass: "keen-slider",
          style: [this.options.vertical ? { height: " 35px" } : {}],
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.slider && this.options.arrows
        ? _c("button", {
            class: {
              arrow: true,
              "arrow--left": true,
              "arrow--disabled": _vm.current === 0,
            },
            on: {
              click: function ($event) {
                return _vm.slider.prev()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.slider && this.options.arrows
        ? _c("button", {
            class: {
              arrow: true,
              "arrow--right": true,
              "arrow--disabled":
                _vm.current === _vm.slider.track.details.slides.length - 1,
            },
            on: {
              click: function ($event) {
                return _vm.slider.next()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.slider && this.options.dots
        ? _c(
            "div",
            { staticClass: "dots" },
            _vm._l(_vm.dotHelper, function (_slide, idx) {
              return _c("button", {
                key: idx,
                class: { dot: true, active: _vm.current === idx },
                on: {
                  click: function ($event) {
                    return _vm.slider.moveToIdx(idx)
                  },
                },
              })
            }),
            0
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }